export default __webpack_public_path__ + "static/pic3-a69e5fa49ce958565650b288d6790383.png";